const PropTypes = require('prop-types');
// @vendors
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
const PureRenderMixin = require('react-addons-pure-render-mixin');

// @commons
const { formatText, getFinalTitle } = require('core/i18n').i18n;
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');

// @actions
const { getLastNChars } = require('utilities/stringHelper');

// @ Loans
const { okLoansComponents } = require('ok-loans');

// @components
const AccountDetailsSideBar = require('components/accounts/accountDetailsSidebar/accountDetailsSidebar');
const AccountMoreOptionsButton = require('components/accounts/accountMoreOptionsButton/accountMoreOptionsButton');
const { LoadingSection } = require('commonsComponents/loadingSection');
const LoansCreditsMoreOptionsButton = okLoansComponents.loansCreditsMoreOptionsButton;
const { AccountSettlements } = require('components/accounts/accountSettlements/accountSettlements');
const { CallMeBack } = require('components/callMeBack/callMeBack');

// @utilities
const AccessHelper = require('utilities/accessHelper');

// @constants
const { accountConstants } = require('utilities/accessHelperConditions/accounts');

class AccountSettlementsView extends React.Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    componentDidMount() {
        const { history, immAccounts, match: { params: { accountId } } } = this.props;

        AccessHelper.allowAccess(accountConstants.ACCOUNTS_SETTLEMENTS, { immAccounts, accountId }, history);
    }

    render() {
        const { match: { params: { accountId, creditType } }, immAccounts } = this.props;
        const immAccount = immAccounts.get('byId').get(accountId);
        let content;

        if (immAccount) {
            const subtitleLeft = immAccount.get('catalogData').get('subtype');
            const subtitleRight = getLastNChars(immAccount.get('iban'));
            const mappingBreadcrumb = [
                {
                    text: formatText('breadcrumb-accounts'),
                    url: '/myprofile/accounts'
                },
                {
                    text: immAccount.get('alias'),
                    url: !creditType ? `/myprofile/accounts/${accountId}/movements` : `/myprofile/loans-mortgages/credit/investment-credit/${accountId}`
                },
                {
                    text: formatText('breadcrumb-accountSettlements'),
                    url: `/myprofile/accounts/${accountId}/settlements`
                }
            ];
            let moreOptionsButton;

            if (creditType) {
                moreOptionsButton = <LoansCreditsMoreOptionsButton id={accountId} type={creditType} />
            } else {
                moreOptionsButton = <AccountMoreOptionsButton accountId={accountId} />;
            }

            content = (
                <div>
                    <div className="container-fluid">
                        <div className="row">
                            <OKCover size="medium" section="accounts" customClass="col-xs-12">
                                <OKHeaderSubPage
                                    breadcrumbConfig={mappingBreadcrumb}
                                    subtitleLeft={subtitleLeft}
                                    subtitleRight={subtitleRight}
                                    finalTitle={getFinalTitle('accountSettlements-title')}>
                                    {moreOptionsButton}
                                </OKHeaderSubPage>
                            </OKCover>
                        </div>
                    </div>
                    <div className="grid-view__body">
                        <div className="container-fluid">
                            <div className="row grid-view--content-position-negative">
                                {/* >> CONTENT DUPLICATED: REF-01 */}
                                <div className="col-xs-12 hidden-md hidden-lg grid-view--fix-cell-separation-bottom">
                                    <AccountDetailsSideBar immAccount={immAccount} />
                                </div>
                                {/* CONTENT DUPLICATED: REF-01 << */}
                                <div className="col-xs-12 col-md-8">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <OKSectionBox>
                                                <AccountSettlements accountId={accountId} />
                                            </OKSectionBox>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xs-12 col-md-4">
                                    <div className="row">
                                        {/* >> REF-01 */}
                                        <div className="hidden-xs hidden-sm col-md-12 grid-view--variable-cell-separation">
                                            <AccountDetailsSideBar immAccount={immAccount} />
                                        </div>
                                        {/* REF-01 << */}
                                        <div className="col-xs-12 col-sm-6 col-md-12 grid-view--fix-cell-separation">
                                            <CallMeBack pageTitle={formatText('breadcrumb-accounts')} hasEntrance={false} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            content = <LoadingSection />;
        }

        return content;
    }
}

AccountSettlementsView.propTypes = {
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired
};

module.exports.constructor = AccountSettlementsView;
module.exports.AccountSettlementsView = connect(
    state => ({
        immAccounts: state.accounts
    })
)(withRouter(AccountSettlementsView));
